export default __webpack_public_path__ + "static/media/Lyuk_kontavatel1.e4770aeb.png";